export const TRUST_CENTER = {
  TITLE: 'Trust Center',
  TOTAL_VISITS: 'Total visits',
  INDIVIDUAL_PAGE_VIEWS: 'Individual page views',
  RESOURCE_DOWNLOADS: 'Resource downloads',
  SINCE_LAST_WEEK: '% since last week',
}
